<template>
  <IntegrationsList :main-label="$t('connectedPS')">
    <template v-if="providers.length">
      <IntegrationsListItem v-for="(provider,i) in providers" :key="i"
                            :provider="provider"
                            :disabled="disableButtons"
                            @edit="$emit('edit',provider)"
                            @refresh="$emit('refresh',provider)"/>
    </template>
    <div v-else class="text-md font-medium text-text-ternary leading-tight mt-4">{{ $t('noConnectedBanks') }}</div>
  </IntegrationsList>
</template>

<script>
import IntegrationsList from "@/components/cabinet/SpaceSettings/BanksIntegrations/IntegrationsList/IntegrationsList";
import IntegrationsListItem
  from "@/components/cabinet/SpaceSettings/BanksIntegrations/IntegrationsList/IntegrationsListItem";

export default {
  name: "PaymentsIntegrationsList",
  components: {IntegrationsListItem, IntegrationsList},
  props: {
    providers: {
      type: Array,
      required: true
    },
    disableButtons: {
      type: Boolean
    }
  },
  i18n: {
    messages: {
      en: {
        connectedPS: 'Payment systems',
        noConnectedBanks: 'No connected payment systems'
      },
      ru: {
        connectedPS: 'Платежные системы',
        noConnectedBanks: 'Нет подключенных платежных систем'
      }
    }
  }
}
</script>